/* eslint-disable react-native/no-inline-styles */
import React from 'react'
import { ViewPropTypes, View, Dimensions } from 'react-native'
import PropTypes from 'prop-types'

import ContentLoader, { Rect } from 'react-content-loader/native'

import { Colors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import RadioButton from './RadioButton'

import styles from './RadioGroup.Styles'

const { width } = Dimensions.get('screen')


const Loader = ({ theme }) => {
    return (
        <ContentLoader
            speed={2}
            width={width - 32}
            height={30}
            backgroundColor={theme?.colors?.shimmerCenterColor}
            foregroundColor={theme?.colors?.shimmerEdgesColor}
            style={styles.textContentLoader}
        >
            <Rect x="4" y="4" rx="5" ry="5" width={25} height={25} />
            <Rect x="40" y="9" rx="5" ry="5" width={120} height={16} />
            <Rect x={width - 76} y="4" rx="5" ry="5" width={25} height={25} />
        </ContentLoader>
    )

}

function RadioGroup(props) {
    const {
        options,
        style,
        optionStyle,
        activeOptionStyle,
        labelStyle,
        activeLabelStyle,
        selected,
        setSelected,
        isLoading,
        theme,
    } = props

    return (
        <View style={[styles.container, style]}>
            {options.map((item, index) => {
                const active = item.value === selected

                if (isLoading) {
                    return (
                        <Loader theme={theme} />
                    )
                }
                return (
                    <RadioButton
                        id={item.value}
                        label={item.label}
                        isActive={active}
                        optionStyle={index === options.length - 1 ? { ...optionStyle, borderBottomWidth: 0 } : { optionStyle }}
                        activeOptionStyle={activeOptionStyle}
                        labelStyle={labelStyle}
                        activeLabelStyle={activeLabelStyle}
                        setSelected={setSelected}
                        disabled={!setSelected}
                        icon={item?.icon}
                        theme={theme}
                    />
                )
            })}
        </View>
    )
}

RadioGroup.defaultProps = {
    options: [],
    style: {},
    optionStyle: {},
    activeOptionStyle: {},
    labelStyle: {},
    activeLabelStyle: {},
    selected: -1,
    setSelected: () => { },
}

RadioGroup.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([
                PropTypes.number,
                PropTypes.string,
            ]),
            label: PropTypes.string,
        })
    ),
    style: ViewPropTypes.style,
    optionStyle: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]),
    activeOptionStyle: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]),
    labelStyle: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]),
    activeLabelStyle: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]),
    selected: PropTypes.string,
    setSelected: PropTypes.func,
    isLoading: PropTypes.bool,
}

export default withTheme(RadioGroup)
